import React from 'react';
import { Checkbox, FormControlLabel, FormGroup, FormLabel, Typography } from '@material-ui/core';
import { AnimalActivity } from './types';

class IProps {
  activities: AnimalActivity[] = [];
  horizontal: boolean = false;
  toggleActivity: any;
}

const ActivityLegend: React.FC<IProps> = ({ activities, toggleActivity, horizontal }) => {
  const toggle = (name: string) => {
    if (activities) {
      const newActivities = activities.map((activity) => {
        if (activity.key === name) {
          return { ...activity, isSelected: !activity.isSelected };
        }
        return activity;
      });

      toggleActivity(newActivities);
    }
  };

  return (
    <>
      <FormGroup row={horizontal}>
        {activities.length > 0 && (
          <FormLabel style={{ alignSelf: horizontal ? 'center' : 'start', marginRight: 8 }} component="legend">
            Activities (Y axis):
          </FormLabel>
        )}
        {activities.length === 0 && (
          <FormLabel style={{ alignSelf: horizontal ? 'center' : 'start', marginRight: 8 }} component="legend">
            No activities.
          </FormLabel>
        )}
        {activities?.map((activity, index) => {
          return (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  checked={activity.isSelected}
                  size="small"
                  onChange={() => toggle(activity.key)}
                  name={activity.key}
                />
              }
              label={<Typography style={{ color: activity.color }}>{activity.key}</Typography>}
            />
          );
        })}
      </FormGroup>
    </>
  );
};

export default ActivityLegend;
